import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0c8d6f70"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "book-confirmation-container" }
const _hoisted_2 = {
  ref: "contentArea",
  class: "content-area book-history"
}
const _hoisted_3 = { class: "book-confirmation-info" }
const _hoisted_4 = { class: "day-seat-info" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "section-divider top" }, null, -1 /* HOISTED */))
const _hoisted_6 = {
  key: 0,
  class: "fare-info"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "section-divider top" }, null, -1 /* HOISTED */))
const _hoisted_8 = {
  key: 1,
  class: "qrcode-wrapper"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "section-divider top" }, null, -1 /* HOISTED */))
const _hoisted_10 = {
  key: 0,
  class: "notice"
}
const _hoisted_11 = {
  key: 2,
  class: "service-evaluation-wrapper"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "section-divider top" }, null, -1 /* HOISTED */))
const _hoisted_13 = { key: 0 }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "해당 월예약을 취소하시겠습니까?", -1 /* HOISTED */))
const _hoisted_15 = {
  key: 0,
  class: "modal-content-month-cancel"
}
const _hoisted_16 = {
  key: 1,
  class: "modal-content"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode($setup["NavigationBar"], {
        shouldHideBackButton: true,
        shouldShowUnderline: true,
        title: "상세내역",
        onOnClickClose: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('onClickClose')))
      }),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("section", _hoisted_3, [
          _createVNode($setup["BookHistoryDetailInfo"], {
            bookInfo: $props.bookInfo,
            onOnClickBusStopLocation: $setup.onClickBusStopLocation
          }, null, 8 /* PROPS */, ["bookInfo"])
        ]),
        _createElementVNode("section", _hoisted_4, [
          _hoisted_5,
          ($setup.isMonthlyBook)
            ? (_openBlock(), _createBlock($setup["MultipleBookDateSeats"], {
                key: 0,
                isMonthlyBook: $setup.isMonthlyBook,
                lineTurnUid: $props.bookInfo.turnId ?? '',
                boardingDates: $props.bookInfo.boardingDates!,
                seatAssignYn: $props.bookInfo.seatAssignYn
              }, null, 8 /* PROPS */, ["lineTurnUid", "boardingDates", "seatAssignYn"]))
            : (_openBlock(), _createBlock($setup["SingleBookDateSeats"], {
                key: 1,
                boardDate: $props.bookInfo.boardDate,
                lineTurnUid: $props.bookInfo.turnId ?? '',
                seatNo: $props.bookInfo.seatNo ?? '',
                seatAssignYn: $props.bookInfo.seatAssignYn,
                allocUid: $props.bookInfo.allocUid ?? ''
              }, null, 8 /* PROPS */, ["boardDate", "lineTurnUid", "seatNo", "seatAssignYn", "allocUid"]))
        ]),
        ($props.bookInfo.bookAmount > 0)
          ? (_openBlock(), _createElementBlock("section", _hoisted_6, [
              _hoisted_7,
              _createVNode($setup["BookHistoryTotalAmount"], {
                totalBookAmount: $props.bookInfo.bookAmount,
                pgCode: $props.bookInfo.pgCode,
                totalCancelAmount: $props.bookInfo.bookCancelAmount,
                cancelAnnotation: "월금액-(탑승일x일금액)",
                isMonthlyBook: $setup.isMonthlyBook
              }, null, 8 /* PROPS */, ["totalBookAmount", "pgCode", "totalCancelAmount"])
            ]))
          : _createCommentVNode("v-if", true),
        ($props.bookInfo.bookStatus === $setup.BookStatusName.BOOK)
          ? (_openBlock(), _createElementBlock("section", _hoisted_8, [
              _hoisted_9,
              (
            $props.bookInfo.bookIntervalCode === $setup.BookIntervalCode.DAY &&
            $props.bookInfo.bookCancelEndDateTime
          )
                ? (_openBlock(), _createElementBlock("p", _hoisted_10, " * 예약취소는 " + _toDisplayString($props.bookInfo.bookCancelEndDateTime) + "까지 가능합니다. ", 1 /* TEXT */))
                : _createCommentVNode("v-if", true),
              ($setup.serviceInfo?.boardCheckCode === $setup.BoardCheckCode.QRTAG)
                ? (_openBlock(), _createBlock($setup["QRCode"], { key: 1 }))
                : _createCommentVNode("v-if", true)
            ]))
          : _createCommentVNode("v-if", true),
        ($setup.lineSurvey)
          ? (_openBlock(), _createElementBlock("section", _hoisted_11, [
              _hoisted_12,
              _createVNode($setup["ServiceEvaluationQuestions"], {
                ref: "serviceEvaluationQuestions",
                lineSurvey: $setup.lineSurvey
              }, null, 8 /* PROPS */, ["lineSurvey"])
            ]))
          : _createCommentVNode("v-if", true)
      ], 512 /* NEED_PATCH */),
      ($setup.props.bookInfo.bookStatus === $setup.BookStatusName.BOOK)
        ? (_openBlock(), _createBlock($setup["FooterButton"], {
            key: 0,
            class: "btn-footer",
            title: "예약취소",
            onOnClickFooterButton: $setup.showBookCancelModal,
            disabled: $setup.cancelBookInProgress
          }, null, 8 /* PROPS */, ["disabled"]))
        : _createCommentVNode("v-if", true),
      ($setup.props.bookInfo.bookStatus === $setup.BookStatusName.BOARD && !!$setup.lineSurvey)
        ? (_openBlock(), _createBlock($setup["FooterButton"], {
            key: 1,
            class: "btn-footer",
            title: "평가완료",
            onOnClickFooterButton: $setup.responseServiceEvaluation,
            disabled: !$setup.isEvaluable
          }, null, 8 /* PROPS */, ["disabled"]))
        : _createCommentVNode("v-if", true),
      ($setup.contentArea)
        ? (_openBlock(), _createBlock($setup["ScrollTopControl"], {
            key: 2,
            container: $setup.contentArea
          }, null, 8 /* PROPS */, ["container"]))
        : _createCommentVNode("v-if", true)
    ]),
    _createVNode($setup["CancelKcp"], {
      ref: "cancelKcpRef",
      isDailyBook: $props.bookInfo.bookIntervalCode === $setup.BookIntervalCode.DAY,
      bookUid: $props.bookInfo.id,
      bookDetailUid: $props.bookInfo.bookDetailId,
      onOnBookCancelResult: $setup.onBookCancelResult
    }, null, 8 /* PROPS */, ["isDailyBook", "bookUid", "bookDetailUid"]),
    ($setup.shouldShowBookCancelModal)
      ? (_openBlock(), _createBlock($setup["Modal"], {
          key: 0,
          title: "예약취소",
          okButtonTitle: "예",
          cancelButtonTitle: "아니오",
          onOnClickOkButton: $setup.requestCancelBook,
          onOnClickCancelButton: _cache[1] || (_cache[1] = ($event: any) => ($setup.shouldShowBookCancelModal = false))
        }, {
          default: _withCtx(() => [
            ($setup.isMonthlyBook)
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                  _hoisted_14,
                  ($setup.isValidRefund)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_15, " [환불예정 금액: " + _toDisplayString($setup.monthlyBookRefund) + "원] ", 1 /* TEXT */))
                    : _createCommentVNode("v-if", true)
                ]))
              : (_openBlock(), _createElementBlock("p", _hoisted_16, "해당 예약을 취소하시겠습니까?"))
          ]),
          _: 1 /* STABLE */
        }))
      : _createCommentVNode("v-if", true),
    _createVNode($setup["PageModal"], {
      shouldShow: $setup.shouldShowMap,
      onBackHandler: () => $setup.toggleShowMap(false)
    }, {
      default: _withCtx(() => [
        _createVNode($setup["MapOfBusStop"], {
          class: "map",
          targetBusStop: $setup.selectedBusStop,
          onOnClickClose: _cache[2] || (_cache[2] = ($event: any) => ($setup.toggleShowMap(false)))
        }, null, 8 /* PROPS */, ["targetBusStop"])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["shouldShow", "onBackHandler"])
  ], 64 /* STABLE_FRAGMENT */))
}